module.exports = __webpack_public_path__ + "static/img/xf.25ad7ac8.png";